// import * as firebase from "./firebase";
import { db } from "./firebase";
import { authApi } from "./auth";
import { facturama } from "./Facturama/facturama.api";
const Facturama = facturama();

/*--------- HELPER FUNCTIONS ---------*/
// Note:
//    This functions should only be used in the main API
//    (as if they were private to the object).
//    This obj is only exported to use in our testing framework only.
export const helpers = {
  /**
   * Sets a document with a specified ID.
   * Returns true or false based on success of operation.
   * @param  {} collection  Collection in which the document will be created.
   * @param  {} docId       The ID which will be assigned to the document.
   * @param  {} obj         The key-value object containing the document's data.
   * @return Promise. Resolves with True or False, based on the success of the operation.
   */
  SetDocWithId(collection, docId, obj) {
    return new Promise((resolve) => {
      try {
        db.collection(collection)
          .doc(docId)
          .set(obj)
          .then(() => {
            resolve(true);
          });
      } catch (error) {
        console.log("Error in SetDocWithId: " + error.message);
        resolve(false);
      }
    });
  },

  /**
   * Adds a document to a collection.
   * Please note that it will be added with a random ID.
   * @param  {} collection  Collection in which the document will be added.
   * @param  {} obj         The key-value object containing the document's data.
   * @return Promise. Resolves to an object {success, ref} (where success is
   *          the success status of the operation and ref is the reference to the document)
   */
  AddDoc(collection, obj) {
    return new Promise((resolve) => {
      try {
        db.collection(collection)
          .add(obj)
          .then((docRef) => {
            resolve({ success: true, ref: docRef });
          });
      } catch (error) {
        console.log("Error in AddDoc function: " + error.message);
        resolve({ success: false, ref: null });
      }
    });
  },
  /**
   * Gets all data from a collection.
   * Please note that it will be added with a random ID.
   * @param  {} collection  Collection in which the document will be added.
   * @return Promise with all data from the DB's collection.
   */
  GetCollection(collection) {
    return new Promise((resolve) => {
      try {
        db.collection(collection)
          .get()
          .then((result) => {
            let dataArray = [];
            result.docs.forEach((doc) => {
              let docData = doc.data();
              docData.id = doc.id;
              dataArray.push(docData);
            });
            resolve(dataArray);
          });
      } catch (error) {
        console.log(error.message);
        resolve(null);
      }
    });
  },
  /**
   * Deletes a whole collection.
   * @param  {} collection  Collection to be deleted.
   * @return Promise. Resolves to true/false based on success of the operation.
   */
  DeleteCollection(collection) {
    return new Promise((resolve) => {
      try {
        db.collection(collection)
          .get()
          .then((response) => {
            response.docs.forEach((doc) => {
              doc.ref.delete();
            });
            resolve(true);
          });
      } catch (error) {
        console.log("Error in DeleteCollection: " + error.message);
        resolve(false);
      }
    });
  },

  /**
   * Executes a query in a collection.
   * @param  {} collection  The collection in which the query will run.
   * @param  {} field       The field (key) we're searching.
   * @param  {} operator    The operator (==, !=, <, >, etc.).
   * @param  {} value       The value we're looking for
   * @return Promise. Resolving with either an array containing the result, or null
   *          in case nothing there was an error.
   */
  Query(collection, field, operator, value) {
    return new Promise((resolve) => {
      try {
        db.collection(collection)
          .where(field, operator, value)
          .get()
          .then((result) => {
            let return_value = [];
            result.forEach((item) => {
              return_value.push(item);
            });
            resolve(return_value);
          });
      } catch (error) {
        console.log(error.message);
        resolve(null);
      }
    });
  },

  /**
   * Deletes a document from a collection.
   * @param  {} collection  The collection in which the document exists.
   * @param  {} id          ID of the document to delete.
   * @return Promise. Resolves with true or false based on the success of the operation.
   */
  DeleteDocument(collection, id) {
    return new Promise((resolve) => {
      try {
        db.collection(collection)
          .doc(id)
          .delete()
          .then(() => {
            resolve(true);
          });
      } catch (error) {
        console.log("Error in DeleteDocument" + error.message);
        resolve(false);
      }
    });
  },

  // ----- ROLES HELPERS -----
  /**
   * Adds the roles to use in the project.
   */
  async SetupRoles() {
    await this.DeleteCollection("Roles");

    // Admin
    this.SetDocWithId("Roles", "Admin", {
      id: 1,
      desc: "Rol administrativo, tiene todos los permisos.",
    });

    // Empleado
    this.SetDocWithId("Roles", "Empleado", {
      id: 2,
      desc: "Rol para empleados, no pueden generar facturas.",
    });

    // Registrado
    this.SetDocWithId("Roles", "Registrado", {
      id: 999,
      desc: "Usuario registrado, no tiene permisos.",
    });
  },

  /**
   * Adds the priviledges to use in the project.
   */
  async SetupPrivilegios() {
    await this.DeleteCollection("Privilegios");

    // Consultar Inventario
    this.SetDocWithId("Privilegios", "ConsultarInventario", {
      rol_minimo: 2,
    });

    // Consultar Movimientos
    this.SetDocWithId("Privilegios", "ConsultarMovimientos", {
      rol_minimo: 2,
    });

    // Consultar Devoluciones
    this.SetDocWithId("Privilegios", "ConsultarDevoluciones", {
      rol_minimo: 1,
    });

    // Consultar Personas
    this.SetDocWithId("Privilegios", "ConsultarPersonas", {
      rol_minimo: 1,
    });
  },

  convertBase64toBlob(content, contentType) {
    contentType = contentType || "";
    var sliceSize = 512;
    var byteCharacters = window.atob(content); //method which converts base64 to binary
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType }); //statement which creates the blob
    return blob;
  },
};

/**
 * ========================== DB API ==========================
 * This is the API which we'll use to interact with our database.
 * Please review the HELPER FUNCTIONS (helpers) to familiarize with some handy
 *    functions which will make development easier and more mantainable.
 *
 * DB INTERACTIONS SHOULD ONLY HAPPEN IN THIS FILE, NONE OTHER!
 */
export const dbApi = {
  /**
   * Setups some data in the db to ease testing.
   */
  Setup() {
    helpers.SetupRoles();
    helpers.SetupPrivilegios();
  },

  /**
   * Looks for the role ID value.
   * @param  {} rol The role name of the role we're looking for.
   * @return  Promise. Resolves with the ID of the role, or null in case there
   *          was an error.
   */
  getRoleId(rol) {
    return new Promise((resolve) => {
      helpers
        .Query("Roles", "__name__", "==", rol)
        .then((result) => {
          result.forEach((doc) => {
            resolve(doc.data().id);
          });
        })
        .catch((error) => {
          console.log(error.message);
          resolve(null);
        });
    });
  },

  /**
   * Signs up creating the user on our DB.
   * Sets the user's role ID to that of a registered user, and the display
   *  name from Google's data.
   * @param  {} uid         The UID of the user (this should come from Google!).
   * @param  {} displayName The display name to add (this should come from Google!).
   * @return  TODO: If you read this, please refactor this method to be a promise and
   *          resolve to true or false based on the success of the operation.
   */
  async SignUp(uid, displayName) {
    db.collection("Usuarios")
      .where("__name__", "==", uid)
      .get()
      .then((result) => {
        if (result.size != 1) {
          this.getRoleId("Registrado").then((registered_rol_id) => {
            helpers.SetDocWithId("Usuarios", uid, {
              id_rol: registered_rol_id,
              displayName: displayName,
            });
          });
        }
      })
      .catch((error) => {
        console.log("Error in SignUp: " + error.message);
      });
  },

  /**
   * Gets the role ID of a user.
   * @param  {} uid The user ID of which we're looking to get the role ID.
   * @return Promise. Resolves to the role ID or false in case there was an error.
   */
  GetUserRoleId(uid) {
    return new Promise((resolve) => {
      db.collection("Usuarios")
        .doc(uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            resolve(doc.data().id_rol);
          } else {
            resolve(false);
          }
        })
        .catch((error) => {
          console.log("Error in GetUserRoleID: " + error.message);
          resolve(false);
        });
    });
  },

  /**
   * Get a the privileges the current user has.
   * @return  Promise. Resolves to a list of the permissions the user has, or null
   *          in case there was an error.
   */
  GetCurrentUserPermissions() {
    return new Promise(async (resolve) => {
      if (authApi.authenticated()) {
        const user_role = await this.GetUserRoleId(authApi.getUid());
        const permissions_query = await helpers.Query(
          "Privilegios",
          "rol_minimo",
          ">=",
          user_role
        );
        const permissions = [];
        permissions_query.forEach((doc) => {
          permissions.push(doc.id);
        });
        resolve(permissions);
      } else {
        resolve(null);
      }
    });
  },

  /**
   * Checks if the current user has a certain privilege.
   * @param  {} permission_name the privilege's/permission's name we want to check for.
   * @return  Promise. Resolves to true or false based on if the user has the privilege.
   */
  HasPermission(permission_name) {
    return new Promise(async (resolve) => {
      const permissions = await this.GetCurrentUserPermissions();
      if (permissions == null) resolve(false);
      resolve(permissions.includes(permission_name));
    });
  },

  AddProduct(newProduct) {
    return new Promise(async (resolve) => {
      Facturama.Products.Create(newProduct, function (result) {
        resolve(result);
      });
    });
  },

  getCatalogProducts(word) {
    return new Promise(async (resolve) => {
      Facturama.Catalogs.ProductsOrServices(word, function (result) {
        resolve(result);
      });
    });
  },

  /**
   * Gets all products registered in DB.
   * @return Promise. Resolves to a list of products or null in case there was an error.
   */
  GetProducts() {
    return new Promise((resolve) => {
      //obtener todos los productos
      Facturama.Products.List(function (result) {
        resolve(result);
      });
    });
  },
  UpdateProduct(model) {
    Facturama.Products.Update(model.Id, model, function (result) {
      resolve(result);
    });
  },

  /**
   * Gets one product registered in DB.
   * @param  ProductId The id of the product.
   * @return Promise. Resolves to a list of products or null in case there was an error.
   */
  GetProduct(ProductId) {
    return new Promise((resolve) => {
      try {
        Facturama.Products.Get(ProductId, (result) => {
          resolve(result);
        });
      } catch (error) {
        console.log(error.message);
        resolve(null);
      }
    });
  },

  /**
   * Get all items in inventory.
   * @return Promise. Resolves with list of objects.
   */
  GetInventory() {
    return new Promise(async (resolve) => {
      const ret = await helpers.GetCollection("Inventario");
      resolve(ret);
    });
  },

  GetPeople() {
    return new Promise((resolve) => {
      //obtener todos los clientes
      Facturama.Clients.List(function (result) {
        resolve(result);
      });
    });
  },

  // returns info from all users
  /**
   * Gets a list of all the users registered in the DB.
   * @return Promise. Resolves to a list of all users, or null in case
   *         there was an error.
   */
  GetAllUsers() {
    return new Promise((resolve) => {
      db.collection("Usuarios")
        .get()
        .then((result) => {
          const ReturnValue = [];
          result.forEach((doc) => {
            const User = {
              uid: doc.id,
              displayName: doc.data().displayName,
              id_rol: doc.data().id_rol,
            };
            ReturnValue.push(User);
          });
          resolve(ReturnValue);
        })
        .catch((error) => {
          console.log("Error in GetAllUsers: " + error.message);
          resolve(null);
        });
    });
  },

  /**
   * Retrieves a list of all roles in our DB.
   * @return  Promise. Resolves to a list of objects [{rolName, rol_id}] or
   *          null in case there was an error.
   */
  GetAllRoles() {
    return new Promise((resolve) => {
      db.collection("Roles")
        .get()
        .then((result) => {
          const returnValue = [];
          result.forEach((doc) => {
            const rol = {
              rolName: doc.id,
              rol_id: doc.data().id,
            };
            returnValue.push(rol);
          });
          resolve(returnValue);
        })
        .catch((error) => {
          console.log("Error in GetAllRoles: " + error.message);
          resolve(null);
        });
    });
  },

  /**
   * Updates the role of a given user.
   * TODO: This method could be optimized if it used the UID instead of the user name.
   * @param  {} nombre  Display name of the user.
   * @param  {} rol     the role to assign to the user.
   * @return  True or false based on the success of the operation. Returns null if there was an error.
   */
  async UpdateUser(name, rol, uuid) {
    var user = {
      displayName: name,
      id_rol: rol,
    };

    await db
      .collection("Usuarios")
      .doc(uuid)
      .update(user)
      .catch((error) => {
        console.log("Error in UpdateUser: " + error.message);
        return false;
      });
    return true;
  },

  /**
   * Deletes a product document
   * @param  {} docID
   * @return True. If you see this please refactor this function to return an indicator of succcess.
   */
  async DeleteProducts(docID) {
    Facturama.Products.Remove(docID, function (result) {
      return true;
    });
  },

  RetrievePersonByRfc(Rfc) {
    return new Promise((resolve) => {
      db.collection("Personas")
        .doc(Rfc)
        .get()
        .then((doc) => {
          if (doc.exists) {
            resolve(doc.data());
          } else {
            resolve(false);
          }
        })
        .catch((error) => {
          console.log("Error in RetrievePersonByRfc: " + error.message);
          resolve(false);
        });
    });
  },

  /**
   * Registers a person (client/provider) into the DB.
   * @param  {} CfdiUse         CFDI Use of the person.
   * @param  {} Email           Email address of the person.
   * @param  {} EmailOp1        Email additional option 1 of the person.
   * @param  {} EmailOp2        Email additional option 2 of the person.
   * @param  {} FiscalRegime    Fiscal Regime under which the person operates.
   * @param  {} Name            Name (Business name) of the person.
   * @param  {} Rfc             RFC of the person or business.
   * @return Promise. Resolves to {success}
   */
  AddPeople(
    Country,
    ExteriorNumber,
    InteriorNumber,
    Locality,
    Municipality,
    Neighborhood,
    State,
    Street,
    ZipCode,
    CfdiUse,
    Email,
    EmailOp1,
    EmailOp2,
    FiscalRegime,
    Name,
    Rfc,
    ExtraInfo
  ) {
    return new Promise((resolve) => {
      const PostData = {
        Address: {
          Country: Country,
          ExteriorNumber: ExteriorNumber,
          InteriorNumber: InteriorNumber,
          Locality: Locality,
          Municipality: Municipality,
          Neighborhood: Neighborhood,
          State: State,
          Street: Street,
          ZipCode: ZipCode,
        },
        CfdiUse: CfdiUse,
        Email: Email,
        EmailOp1: EmailOp1,
        EmailOp2: EmailOp2,
        FiscalRegime: FiscalRegime,
        Name: Name,
        Rfc: Rfc,
        TaxZipCode: ZipCode,
      };

      // Send cfdi request
      Facturama.Clients.Create(
        //const PersonObjec = await this.GetPerson(Person);
        PostData,
        (result) => {
          db.collection("Personas").doc(Rfc).set({
            BankRfc: ExtraInfo.BankRfc,
            ClientAccount: ExtraInfo.ClientAccount,
            BankName: ExtraInfo.BankName,
          });

          resolve({
            success: true,
            client: result,
            message: "Cliente registrado con éxito.",
          });
        },
        (error) => {
          if (error && error.responseJSON) {
            console.log("errores", error.responseJSON);
            resolve({
              success: false,
              client: null,
              message: error.responseJSON,
            });
          }
        }
      );
    });

    return ret;
  },

  /**
   *
   * Get all FiscalRegimens from Facturama
   * @return Promise.
   *
   */

  GetFiscalRegimens() {
    return new Promise((resolve) => {
      Facturama.Catalogs.FiscalRegimens(
        function (result) {
          resolve(result);
        },
        function (error) {
          if (error && error.responseJSON) {
            console.log("errores", error.responseJSON);
            resolve(null);
          }
        }
      );
    });
  },

  /**
   *
   * Get all CfdiUse from Facturama
   * @return Promise.
   *
   */

  GetCfdiUses(Rfc) {
    return new Promise((resolve) => {
      Facturama.Catalogs.CfdiUses(
        Rfc,
        function (result) {
          resolve(result);
        },
        function (error) {
          if (error && error.responseJSON) {
            console.log("errores", error.responseJSON);
            resolve(null);
          }
        }
      );
    });
  },

  /**
   * Gets all data from Personas.
   * @return  Uses GetCollection helper function to get the information from the database.
   */
  async GetPersons() {
    return await helpers.GetCollection("Personas");
  },

  /**
   * Gets all data from Movimientos.
   * @return  Uses GetCollection helper function to get the information from the database.
   */
  async GetMovements() {
    return await helpers.GetCollection("Movimientos");
  },

  /**
   * Updates a payment date in DB.
   * @param  {} movement_id ID of the movement to update (ID of document)
   * @param  {} date        Date to set (null in case no date selected)
   * @return Promise. Resolves to {success: bool, message: str} based on success of operation
   */
  SetMovementPaymentDate(movement_id, date) {
    return new Promise((resolve) => {
      try {
        db.collection("Movimientos")
          .doc(movement_id)
          .update({
            PaymentDate: date,
          })
          .then(() => {
            resolve({
              success: true,
              message: "Fecha de Pago actualizada correctamente.",
            });
          });
      } catch (error) {
        console.log(error.message);
        resolve({ success: false, message: error.message });
      }
    });
  },

  /**
   * Gets user data from DB.
   * @param  {} uid The user id of the user we want to retrieve.
   * @return Promise. Resolves with an object {id, data...} or null in case there was an error.
   */
  async GetUser(uid) {
    return new Promise((resolve) => {
      try {
        db.collection("Usuarios")
          .doc(uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              const return_value = doc.data();
              return_value.id = doc.id;
              resolve(return_value);
            } else {
              resolve(null);
            }
          });
      } catch (error) {
        console.log(error.message);
        resolve(null);
      }
    });
  },

  /**
   * Deletes the user from the data base.
   * @param  {} uid  The user ID of the user we want to delete.
   * @return  True or false based on the success of the operation.
   */
  async DeleteUser(uid) {
    return await helpers.DeleteDocument("Usuarios", uid);
  },

  /**
   * Sends a request to Facturama to post a cfdi 4.0 movement
   * @param  {} PersonObject
   * @param  {} PaymentForm
   * @param  {} PaymentMethod
   * @return Promise. Resolves to {success: bool, cfdi: obj, message: str}
   */
  RegisterCFDI4_0(PersonObject, PaymentForm, PaymentMethod, Products) {
    return new Promise((resolve) => {
      const PostData = {
        CfdiType: "I",
        PaymentForm: PaymentForm,
        PaymentMethod: PaymentMethod,
        ExpeditionPlace: "76246",
        Receiver: {
          Rfc: PersonObject.Rfc,
          CfdiUse: PersonObject.CfdiUse,
          Name: PersonObject.Name,
          FiscalRegime: PersonObject.FiscalRegime,
          TaxZipCode: PersonObject.TaxZipCode,
        },
        Items: Products,
      };

      // Send cfdi request
      Facturama.Cfdi.Create3(
        PostData,
        (result) => {
          resolve({
            success: true,
            cfdi: result,
            message: "Movimiento CFDI exitoso.",
          });
        },
        (error) => {
          if (error && error.responseJSON) {
            console.log("errores", error.responseJSON);
            resolve({
              success: false,
              cfdi: null,
              message: error.responseJSON,
            });
          }
        }
      );
    });
  },

  /**
   * Process a transaction in inventory based on a movement
   * @param  {} MovementType
   * @param  {} Person
   * @param  {} Products
   * @param  {} Cfdi
   */
  InventoryTransaction(MovementType, Person, Products, Cfdi) {
    const result = Object.values(
      Products.reduce(
        (
          r,
          { Id, Quantity, Batch, Name, Subtotal, ExpiryDate, Description }
        ) => {
          r[Id] ??= { Id, count: 0, totalQuantity: 0 };
          r[Id].count++;
          r[Id].totalQuantity += Number(Quantity);
          r[Id].Name = Name;
          r[Id].Batch = Batch;
          r[Id].Subtotal = Subtotal;
          r[Id].ExpiryDate = ExpiryDate;
          r[Id].Description = Description;
          return r;
        },
        {}
      )
    );

    return db.runTransaction((txn) => {
      return new Promise((resolve) => {
        // - - - Update inventory - - -
        let inventory_updates = [];
        //Products.forEach();
        Promise.all(
          result.map(async (product) => {
            // Get existing product (if it exists)
            const docref = db
              .collection("Inventario")
              .doc(product.Name + product.Batch);

            const doc = await txn.get(docref);
            if (doc.exists) {
              // Update values
              const previous_amount = Number(doc.data().Cantidad);
              let new_amount = 0;
              if (MovementType == "Entrada") {
                new_amount = previous_amount + Number(product.totalQuantity);
              } else {
                new_amount = previous_amount - Number(product.totalQuantity);
                if (new_amount < 0) {
                  new_amount = 0;
                }
              }
              new_amount = new_amount.toFixed(2);
              //txn.update(docref, { Cantidad: new_amount });
              inventory_updates.push({
                type: "update",
                ref: docref,
                data: { Cantidad: new_amount },
              });
            } else if (MovementType == "Entrada") {
              // Create document
              inventory_updates.push({
                type: "set",
                ref: docref,
                data: {
                  Articulo: product.Name,
                  Cantidad: Number(product.totalQuantity),
                  Precio: product.Subtotal,
                  Lote: product.Batch,
                  FechaDeIngreso: new Date().toISOString(),
                  FechaDeCaducidad: product.ExpiryDate,
                  Nombre: product.Description,
                },
              });
            }
          })
        ).then(() => {
          // - - - Update in txn - - -
          inventory_updates.forEach((operation) => {
            if (operation.type == "update") {
              txn.update(operation.ref, operation.data);
            } else if (operation.type == "set") {
              txn.set(operation.ref, operation.data);
            }
          });

          // - - - Register Movement - - -
          const movementDocRef = db.collection("Movimientos").doc();
          txn.set(movementDocRef, {
            MovementType: MovementType,
            Person: Person,
            Products: Products,
            Date: new Date().toISOString(),
            Cfdi: Cfdi != null ? Cfdi.Id : null,
            PaymentComplements: [],
          });

          resolve(txn);
        });
      });
    });
  },

  /**
   * Registers a Movement in DB.
   * @param  {} MovementType  The type of movement we are to register.
   * @param  {} Person        Id of the Person subject to the movement.
   * @param  {} Products      Array of json objects with data of products.
   * @return Promise. Resolves to {success: true/false, message: str} based on success of the operation.
   */
  RegisterMovement(MovementType, Person, Products, PaymentForm, PaymentMethod) {
    return new Promise(async (resolve) => {
      let should_upload = true;
      let Cfdi = null;
      switch (MovementType) {
        case "Entrada":
          break;
        case "Salida":
          delete Products.ExpiryDate;
          const PersonObject = await this.GetPerson(Person);
          const cfdi_request = await this.RegisterCFDI4_0(
            PersonObject,
            PaymentForm,
            PaymentMethod,
            Products
          );
          // console.log(Products);
          // Products.forEach((item) => {
          //   item.Quantity = item.Quantity.toFixed(2);
          // });

          if (!cfdi_request.success) {
            should_upload = false;
            resolve({ success: false, message: cfdi_request.message });
          } else {
            Cfdi = cfdi_request.cfdi;
          }
          break;
        case "Correccion":
          delete Products.ExpiryDate;
          delete Products.Cost;
          break;
        default:
          should_upload = false;
          break;
      }

      if (should_upload) {
        this.InventoryTransaction(MovementType, Person, Products, Cfdi)
          .then((result) => {
            resolve({
              success: true,
              message: "Movimiento registrado exitosamente.",
            });
          })
          .catch((error) => {
            console.log(error);
            resolve({
              success: false,
              message: error.message,
            });
          });
      } else {
        resolve({
          success: false,
          message: "Los datos seleccionados o enviados son incorrectos.",
        });
      }
    });
  },

  /**
   * Downloads the CFDI in the specified file type.
   * @param  {} cfdi      The CFDI object
   * @param  {} fileType  File type wished to download <"pdf"/"xml">
   */
  DownloadCfdi(cfdi, fileType) {
    Facturama.Cfdi.Download(fileType, "issued", cfdi, (result) => {
      const blob = helpers.convertBase64toBlob(
        result.Content,
        "application/" + fileType
      );

      var blobURL = URL.createObjectURL(blob);

      if (fileType == "pdf") {
        window.open(blobURL);
      } else if (fileType == "xml") {
        let link = document.createElement("a");
        link.setAttribute("download", "");
        link.href = blobURL;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    });
  },

  /**
   *
   * Deletes the specified person with a given ID.
   * @param  {} docID  The document ID assigned to that client or supplier.
   * @return  True upon operation success.
   */
  async DeletePerson(docID, Rfc) {
    Facturama.Clients.Remove(docID, function (result) {
      helpers.DeleteDocument("Personas", Rfc);
      return true;
    });
  },

  /** */

  async GetCFDI(CFDI) {
    return new Promise((resolve) => {
      Facturama.Cfdi.AGetThatWorks(CFDI, function (result) {
        resolve(result);
      });
    });
  },

  /**
   * Updates the data of a registered Person.
   * @param  {} person  Person object
   * @return  True  based on the success of the operation.
   */

  UpdatePerson(clientID, newClient, ExtraInfo) {
    return new Promise((resolve) => {
      const PostData = {
        Address: {
          Country: newClient.Address.Country,
          ExteriorNumber: newClient.Address.ExteriorNumber,
          InteriorNumber: newClient.Address.InteriorNumber,
          Locality: newClient.Address.Locality,
          Municipality: newClient.Address.Municipality,
          Neighborhood: newClient.Address.Neighborhood,
          State: newClient.Address.State,
          Street: newClient.Address.Street,
          ZipCode: newClient.Address.ZipCode,
        },
        Id: clientID,
        CfdiUse: newClient.CfdiUse,
        Email: newClient.Email,
        EmailOp1: newClient.EmailOp1,
        EmailOp2: newClient.EmailOp2,
        FiscalRegime: newClient.FiscalRegime,
        Name: newClient.Name,
        Rfc: newClient.Rfc,
        TaxZipCode: newClient.Address.ZipCode,
        NumRegIdTrib: "",
        TaxResidence: "",
      };

      Facturama.Clients.Update(
        clientID,
        PostData,
        async (result) => {
          const prueba = await db
            .collection("Personas")
            .doc(PostData.Rfc)
            .update(ExtraInfo)
            .catch((error) => {
              console.log("Error in UpdatePerson: " + error.message);
            });
          console.log(ExtraInfo);
          resolve({
            success: true,
            client: result,
            message: "Persona actualizada con éxito.",
          });
        },
        (error) => {
          if (error && error.responseJSON) {
            console.log("errores", error.responseJSON);
            resolve({
              success: false,
              client: null,
              message: error.responseJSON,
            });
          }
        }
      );
    });
  },
  /**
   * Gets person data from DB.
   * @param  {} pid The id of the person we want to retrieve.
   * @return Promise. Resolves with an object {id, data...} or null in case there was an error.
   */
  async GetPerson(pid) {
    return new Promise((resolve) => {
      Facturama.Clients.Get(pid, function (result) {
        resolve(result);
      });
    });
  },
  async CreateComplement(complement, idMovement) {
    return new Promise((resolve) => {
      try {
        Facturama.Cfdi.Create(complement, function (result) {
          const document = db.collection("Movimientos").doc(idMovement);

          document.get().then((doc) => {
            var array = doc.data().PaymentComplements;
            array.push(result.Id);
            document.update({
              PaymentComplements: array,
            });
          });

          resolve({ success: true, message: "Complemento Exitoso" });
        });
      } catch (error) {
        resolve({ success: false, message: error.message });
      }
    });
  },
  /* Updates the move of an operation.
   * @param  {} move  Move object
   * @return  True  based on the success of the operation.
   */
  async UpdateMove(move) {
    var updatedMove = {
      type: move.type,
      personId: move.personId,
      productId: move.productId,
      amount: move.amount,
      batch: move.batch,
      saleByDate: move.saleByDate,
      quantity: move.quantity,
      date: move.date,
    };
    await db.collection("Movimientos").doc(move.id).update(updatedMove);
    return true;
  },

  /* Gets the payment method catalog.
   * @return  List .
   */
  GetPaymentMethodCatalog() {
    return new Promise((resolve) => {
      Facturama.Catalogs.PaymentMethods(
        function (result) {
          resolve(result);
        },
        function (error) {
          if (error && error.responseJSON) {
            console.log("errores", error.responseJSON);
            resolve(null);
          }
        }
      );
    });
  },

  /* Gets the payment form catalog.
   * @return  List .
   */
  GetPaymentFormCatalog() {
    return new Promise((resolve) => {
      Facturama.Catalogs.PaymentForms(
        function (result) {
          resolve(result);
        },
        function (error) {
          if (error && error.responseJSON) {
            console.log("errores", error.responseJSON);
            resolve(null);
          }
        }
      );
    });
  },

  GetBatches(Name) {
    return new Promise((resolve) => {
      const Batches = [];
      helpers.Query("Inventario", "Articulo", "==", Name).then((snapshot) => {
        snapshot.forEach((element) => {
          Batches.push({
            batch: element.data().Lote,
            quantity: element.data().Cantidad,
          });
        });
        resolve(Batches);
      });
    });
  },
};
